export const RECALCULATE_SIZE_INTERVAL = 500;
